"use client"
import React, { useState, useEffect, useRef, useMemo } from 'react';

import DataTableListGenerica from '../DataTableListGenerica/DataTableListGenerica'
import { Skeleton } from 'primereact/skeleton';
import { Inplace, InplaceDisplay, InplaceContent } from 'primereact/inplace';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Badge } from 'primereact/badge';
import { Chip } from 'primereact/chip';
import { PrimeIcons } from 'primereact/api';
import lodash from "lodash";
//import { Captcha } from 'primereact/captcha';
import ReCAPTCHA from 'react-google-recaptcha';
import dynamic from 'next/dynamic';
import { InputOtp } from 'primereact/inputotp';
import { Password } from 'primereact/password';
import { SelectButton } from 'primereact/selectbutton';

//import JoditEditor from 'jodit-react';

import Link from 'next/link';


import { htmlToText } from "html-to-text";
import wordsCount from 'words-count';


import { GenericaSistemaService } from '../../service/GenericaSistemaService';
import AuthStorage from '../../storage/AuthStorage';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';
import { ColorPicker } from 'primereact/colorpicker';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';

import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';

import Document from './Document';
import { usePrevious } from 'primereact/hooks';

import "../../assets/css/Formulario.css";

const JoditEditor = dynamic(() => import('jodit-react'), {
    ssr: false,
    loading: () => <p>Cargando editor...</p>
});

const Formulario = React.forwardRef((props, ref) => {

    const [date, setDate] = useState(null);
    console.log("Formulario, ");

    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();
    const { userName, idEmpresa, idioma, sessionGUID } = userDetails;

    const genericaSistemaService = new GenericaSistemaService();

    const etiquetasModulo = props.etiquetasModulo;
    const genericaSistemaDialog = props.genericaSistemaDialog;

    const requiereConfirmacionOPT = props.requiereConfirmacionOPT;
    const [esperandoConfirmacionOPT, setEsperandoConfirmacionOPT] = useState(false);



    const [optionsSelectButton, setOptionsSelectButton] = useState(undefined);

    const utilizaDialog = props.utilizaDialog !== undefined ? props.utilizaDialog : true;

    const genericaSistemaDialogRef = useRef(null);
    const toast = useRef(null);

    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);

    const [metadataGenericaSistemaForm, setMetadataGenericaSistemaForm] = useState([]);

    const genericaSistemaBase = useRef({});
    const [genericaSistema, setGenericaSistema] = useState({});

    const [selectedTipoGenericaConfirmacionOpt, setSelectedTipoGenericaConfirmacionOpt] = useState(undefined);
    const [genericaSistemaConfirmacionOpt, setGenericaSistemaConfirmacionOpt] = useState({});
    const [metadataGenericaSistemaConfirmacionOpt, setMetadataGenericaSistemaConfirmacionOpt] = useState([]);


    const [visibleConfirm, setVisibleConfirm] = useState(false);

    const [cargado, setCargado] = useState(false);
    const [submitting, setSubmitting] = useState(false);


    const refBtGuardarDialogFooter = useRef(undefined);
    const prevSelectedTipoGenericaRef = useRef(undefined);

    const _ = lodash;

    const customInput = ({ events, props }) => {
        return <><input {...events} {...props} type="text" className="custom-otp-input-sample" />
            {props['data-index'] === 2 && <div className="px-3">
                <i className="pi pi-minus" />
            </div>}
        </>
    };
    const valorMaximoDefaultPorTipoDato = (tipoDato) => {
        if (tipoDato === "text") {
            return 1000;
        }
        else if (tipoDato === "file") {
            return 1;
        }
        else
            return 50000;
    }

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const generarValidadoresMetadata = (metadataBase, val, comodinValidacionGeneral, _genericaSistemaBase) => {


        let metadata = { ...metadataBase };
        let genericaSistemaBase = _genericaSistemaBase || genericaSistema;

        let ingresado = false;

        if (val === undefined && comodinValidacionGeneral !== undefined) {
            val = genericaSistemaBase.uts !== undefined ? genericaSistemaBase['uts'][`${metadataBase.campo}`] : undefined;
            ingresado = comodinValidacionGeneral || false;
        }
        else {
            ingresado = val !== undefined;
        }

        let valido = false;
        let evalValMin = "";
        let evalValMax = "";
        evalValMin = metadata.restriccionFormatoMin;
        evalValMax = metadata.restriccionFormatoMax;

        let valMin = undefined;
        let valMax = undefined;
        let valEval = undefined;

        if (metadata.tipoDato === "int" || metadata.tipoDato === "double" || metadata.tipoDato === "money") {

            if (selectedTipoGenerica.variableRestriccionExterna !== undefined
                && ((evalValMin !== null && evalValMin.includes("[[EXTERNO_")) || (evalValMax !== null && evalValMax.includes("[[EXTERNO_")))) {

                Object.keys((selectedTipoGenerica.variableRestriccionExterna)).forEach(variableExterna => {

                    if (evalValMin !== null && evalValMin.includes(variableExterna)) {
                        evalValMin = evalValMin.replace(variableExterna, selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor);
                        //valMin = selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor;
                    }

                    if (evalValMax !== null && evalValMax.includes(variableExterna)) {
                        evalValMax = evalValMax.replace(variableExterna, selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor);
                        //valMax = selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor;
                    }

                });

            }
            else if ((evalValMin !== null && evalValMin.includes("[[")) || (evalValMax !== null && evalValMax.includes("[["))) {

            }

            if (evalValMin !== null && !evalValMin.includes("[[")) {
                valMin = eval(evalValMin);
            }

            if (evalValMax !== null && !evalValMax.includes("[[")) {
                valMax = eval(evalValMax);
            }

            if (val !== undefined) {

                valEval = val;

                console.log("campo, ", metadata.campo, ", valEval number, ", typeof valEval, metadata.esRequerido, valEval, valMin, valMax);

                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval !== undefined));

                valido = valido && valMin !== undefined ? valido * (valEval >= valMin) : valido;
                valido = valido && valMax !== undefined ? valido * (valEval <= valMax) : valido;
            }

        }

        else if (metadata.tipoDato === "boolean") {
            valEval = val;
            valido = valEval === undefined || valEval === null ? false : true;

            if (metadata.formatoDato === "aceptaTerminos") {
                valido = valEval === true;
            }
        }

        else if (metadata.tipoDato === "date") {
            valEval = val;
            valido = false;
            //if ()
            if (val instanceof Date) {
                valido = true;
            }
        }

        else if (metadata.tipoDato === "string") {
            console.log("metadata.tipoDato");

            valMin = eval(evalValMin);
            valMin = valMin !== undefined && valMin !== "" ? valMin : metadata.esRequerido ? 1 : 0;

            valMax = eval(evalValMax);
            valMax = valMax !== undefined && valMax !== "" ? valMax : valorMaximoDefaultPorTipoDato(metadata.tipoDato);

            if (val !== undefined) {

                if (val === null)
                    val = "";

                valEval = (val + "").length;

                //console.log("Else campo, ", metadata.campo, metadata.esRequerido, " - ", metadata.tg, "val: ", val, "valEval: ", valEval, "valMin: ", valMin, "valMax:", valMax);

                if (valMin === undefined && (!metadata.esRequerido || (metadata.esRequerido && valEval > 0))) {
                    valido = (!metadata.esRequerido || (metadata.esRequerido && valEval > 0));
                }
                else {
                    valido = true;
                    valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                };

                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;

                if (valido && metadata.formatoDato === "email") {
                    valido = validateEmail(val) !== null;
                }
                else if (valido && metadata.formatoDato === "NIT") {
                }
                else {

                }

            }
            else {
                valEval = 0;
                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval > 0));
                valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;

            }


        }

        else { //if (metadata.tipoDato === "string" || metadata.tipoDato === "text") {


            valMin = eval(evalValMin);
            valMin = valMin !== undefined && valMin !== "" ? valMin : metadata.esRequerido ? 1 : 0;

            if (metadata.campo === "documento") {
                console.log("dfdfdfdfd", valMin, metadata);
            }


            valMax = eval(evalValMax);
            valMax = valMax !== undefined && valMax !== "" ? valMax : valorMaximoDefaultPorTipoDato(metadata.tipoDato);

            if (val !== undefined) {

                if (val === null)
                    val = "";

                valEval = val.toString();

                if (metadata.tipoDato === "text") {
                    valEval = wordsCount(htmlToText(val));
                }
                else {
                    valEval = valEval.length;
                }

                //console.log("Else campo, ", metadata.campo, metadata.esRequerido, " - ", metadata.tg, "val: ", val, "valEval: ", valEval, "valMin: ", valMin, "valMax:", valMax);

                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval > 0));
                valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;

                if (valido && metadata.formatoDato === "email") {
                    valido = validateEmail(val) !== null;
                }

            }
            else {
                valEval = 0;
                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval > 0));
                valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;

            }


        }

        metadata.valMin = valMin;
        metadata.valMax = valMax;

        metadata.error = "";
        metadata.valido = valido;
        metadata.ingresado = ingresado;
        metadata.valEval = valEval;

        //console.log("dfdfdfdfd", metadata.campo, valido, valEval, valMin, valMax, inicial, metadata);


        return metadata;

    }

    const generarValidadoresData = (metadataBase, val, comodinValidacionGeneral) => {


        let metadata = { ...metadataBase };
        let campo = metadata.campo;

        let ingresado = false;

        if (val === undefined && comodinValidacionGeneral !== undefined) {
            val = genericaSistema.uts !== undefined ? genericaSistema['uts'][`${campo}`] : undefined;
            ingresado = comodinValidacionGeneral || false;
        }
        else {
            ingresado = val !== undefined;
        }

        let valido = false;
        let evalValMin = "";
        let evalValMax = "";
        evalValMin = metadata.restriccionFormatoMin;
        evalValMax = metadata.restriccionFormatoMax;

        let valMin = undefined;
        let valMax = undefined;
        let valEval = undefined;

        if (metadata.tipoDato === "int" || metadata.tipoDato === "double" || metadata.tipoDato === "money") {

            if (selectedTipoGenerica.variableRestriccionExterna !== undefined
                && ((evalValMin !== null && evalValMin.includes("[[EXTERNO_")) || (evalValMax !== null && evalValMax.includes("[[EXTERNO_")))) {

                Object.keys((selectedTipoGenerica.variableRestriccionExterna)).forEach(variableExterna => {

                    if (evalValMin !== null && evalValMin.includes(variableExterna)) {
                        evalValMin = evalValMin.replace(variableExterna, selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor);
                        //valMin = selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor;
                    }

                    if (evalValMax !== null && evalValMax.includes(variableExterna)) {
                        evalValMax = evalValMax.replace(variableExterna, selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor);
                        //valMax = selectedTipoGenerica.variableRestriccionExterna[variableExterna].valor;
                    }

                });

            }
            else if ((evalValMin !== null && evalValMin.includes("[[")) || (evalValMax !== null && evalValMax.includes("[["))) {

            }

            if (evalValMin !== null && !evalValMin.includes("[[")) {
                valMin = eval(evalValMin);
            }

            if (evalValMax !== null && !evalValMax.includes("[[")) {
                valMax = eval(evalValMax);
            }

            if (val !== undefined) {

                valEval = val;

                console.log("campo, ", metadata.campo, ", valEval number, ", metadata.esRequerido, valEval, valMin, valMax);

                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval !== undefined));

                valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;
            }

        }

        else if (metadata.tipoDato === "boolean") {
            valEval = val;
            valido = valEval === undefined || valEval === null ? false : true;
        }

        else if (metadata.tipoDato === "date") {
            valEval = val;
            valido = false;
            //if ()
            if (val instanceof Date) {
                valido = false;
            }

            valido = val instanceof Date;
        }

        else { //if (metadata.tipoDato === "string" || metadata.tipoDato === "text") {


            valMin = eval(evalValMin);
            valMin = valMin !== undefined && valMin !== "" ? valMin : metadata.esRequerido ? 1 : 0;

            if (metadata.campo === "documento") {
                console.log("dfdfdfdfd", valMin, metadata);
            }


            valMax = eval(evalValMax);
            valMax = valMax !== undefined && valMax !== "" ? valMax : valorMaximoDefaultPorTipoDato(metadata.tipoDato);

            if (val !== undefined) {

                if (val === null)
                    val = "";

                valEval = val.toString();

                if (metadata.tipoDato === "text") {
                    valEval = wordsCount(htmlToText(val));
                }
                else {
                    valEval = valEval.length;
                }

                //console.log("Else campo, ", metadata.campo, metadata.esRequerido, " - ", metadata.tg, "val: ", val, "valEval: ", valEval, "valMin: ", valMin, "valMax:", valMax);

                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval > 0));
                valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;

            }
            else {
                valEval = 0;
                valido = (!metadata.esRequerido || (metadata.esRequerido && valEval > 0));
                valido = valido && valMin !== undefined ? valido * valEval >= valMin : valido;
                valido = valido && valMax !== undefined ? valido * valEval <= valMax : valido;

            }


        }

        genericaSistema['test'] = [`${campo}`];

        genericaSistema['test'][`${campo}`]['valMin'] = valMin;
        genericaSistema['test'][`${campo}`]['valMax'] = valMax;
        genericaSistema['test'][`${campo}`]['error'] = "";
        genericaSistema['test'][`${campo}`]['valido'] = valido;
        genericaSistema['test'][`${campo}`]['ingresado'] = ingresado;
        genericaSistema['test'][`${campo}`]['valEval'] = valEval;
        //metadata.valMin = valMin;
        //metadata.valMax = valMax;
        //metadata.error = "";
        //metadata.valido = valido;
        //metadata.ingresado = ingresado;
        //metadata.valEval = valEval;

        //console.log("dfdfdfdfd", metadata.campo, valido, valEval, valMin, valMax, inicial, metadata);


        return metadata;

    }

    if (props.selectedTipoGenerica !== undefined && selectedTipoGenerica == undefined) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
        setEsperandoConfirmacionOPT(false);
    }
    else if (props.selectedTipoGenerica !== undefined) {
        if ((props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg)) {
            setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
            setEsperandoConfirmacionOPT(false);
        }
        else if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            let newSelectedTipoGenerica = {
                ...selectedTipoGenerica, ctiTextoFiltroUts: props.selectedTipoGenerica.ctiTextoFiltroUts,
                filtroUts: { ...props.selectedTipoGenerica.filtroUts }, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }
            };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setEsperandoConfirmacionOPT(false);
        }
        else if (props.selectedTipoGenerica.variableRestriccionExterna !== undefined
            && !_.isEqual(props.selectedTipoGenerica.variableRestriccionExterna, selectedTipoGenerica.variableRestriccionExterna)) {
            let newSelectedTipoGenerica = { ...selectedTipoGenerica, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna } };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setEsperandoConfirmacionOPT(false);
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {
            let newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setEsperandoConfirmacionOPT(false);
        }

    }

    if (selectedTipoGenerica !== undefined) {
        let igualBase = _.isEqual(genericaSistemaBase.current, props.genericaSistema);

        if (!igualBase) {

            //if (genericaSistemaBase.current !== props.genericaSistema) {

            genericaSistemaBase.current = { ...props.genericaSistema };
            setGenericaSistema({ ...props.genericaSistema });

            let newMetadata = [];

            console.log("entre acá", selectedTipoGenerica.tg, "aha", metadataGenericaSistemaForm)
            props.metadataGenericaSistemaForm.forEach(metadata => {
                let newMetada = generarValidadoresMetadata(metadata, props.genericaSistema.uts[metadata.campo], false);
                newMetadata.push(newMetada);
            });


            setMetadataGenericaSistemaForm(newMetadata);

        }
    }


    useEffect(() => {

        let prevselectedTipoGenerica = { ...selectedTipoGenerica }

        if (prevSelectedTipoGenericaRef.current === undefined && selectedTipoGenerica !== undefined) {
            LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
            prevselectedTipoGenerica["intentoMetadata"] = 1;
        }
        else if (prevSelectedTipoGenericaRef.current !== undefined && selectedTipoGenerica !== undefined) {

            if (prevSelectedTipoGenericaRef.current.tg !== selectedTipoGenerica.tg) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = 1;
            }
        }

        prevSelectedTipoGenericaRef.current = prevselectedTipoGenerica;
        // CAMBIO PUERCO
        setCargado(true);

    }, [selectedTipoGenerica])

    const LoadDatosGenerica = async (_tg, idEmpresa, idioma, userName) => {

        if (selectedTipoGenerica.tg !== "" && (selectedTipoGenerica.operaciones === undefined)) {
            console.log("GetTipoGenericaSistemaByTg - Formulario", selectedTipoGenerica);

            genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                let newSelectedTipoGenerica = data.data;

                if (selectedTipoGenerica.filtroUts) {
                    newSelectedTipoGenerica.filtroUts = selectedTipoGenerica.filtroUts;
                    newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                }
                if (selectedTipoGenerica.version) {
                    newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                }

                setSelectedTipoGenerica(newSelectedTipoGenerica);

                if (requiereConfirmacionOPT && metadataGenericaSistemaConfirmacionOpt.length === 0) {



                    genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName,
                        props.selectedTipoGenericaConfirmacionOPT.tg).then(data => {

                            let newSelectedTipoGenericaConfirmacionOpt = data.data;

                            if (selectedTipoGenerica.filtroUts) {
                                newSelectedTipoGenericaConfirmacionOpt.filtroUts = selectedTipoGenerica.filtroUts;
                                newSelectedTipoGenericaConfirmacionOpt.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                            }
                            if (selectedTipoGenerica.version) {
                                newSelectedTipoGenericaConfirmacionOpt.version = selectedTipoGenerica.version;
                            }

                            setSelectedTipoGenericaConfirmacionOpt(newSelectedTipoGenericaConfirmacionOpt);
                            setMetadataGenericaSistemaConfirmacionOpt(data.metadata);

                        });
                }

                if (//(selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA_RA" || selectedTipoGenerica.tg === "ACA_TMP_NOTA_DETALLE_RAP_CRITERIO") || selectedTipoGenerica.tg === "ACA_TMP_NOTA_DETALLE_RAP_CRITERIO")
                    //&& 
                    selectedTipoGenerica.tg === "DMS_VSTA_REGISTRO_ACTA_ASISTENCIA_INVITADO_ATENCION_ESTUDIANTE" && optionsSelectButton === undefined) {

                    //newtgRefSelectItem.tgRef
                    //selectedTipoGenerica.filtroUts
                    genericaSistemaService.getGenericasSistema("DMS_ACTA_ESCALA_SATISFACCION", { lazyEvent: JSON.stringify({}) }, idEmpresa, idioma, userName, {}).then(data => {

                        //console.log("GetOptionsSelectButtonDeTg, ", data);
                        setOptionsSelectButton(data.data);
                    });
                }

            });
        }

        setCargado(selectedTipoGenerica.operaciones !== undefined);


    }


    ref = genericaSistemaDialogRef

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasModulo.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }

    const crearNewEmptyGenerica = (metadata) => {

        let item = {}

        item['tg'] = selectedTipoGenerica.tg;
        item['id'] = 0;
        item['idEmpresa'] = idEmpresa;
        item['idioma'] = idioma;

        item['uts'] = {};

        metadata.forEach(x => {
            if (x.campo === "tg")
                item[`${x.campo}`] = x.tg;
            else {

                let newVal = "";
                if (selectedTipoGenerica.filtroUts !== undefined && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo)) {
                    newVal = selectedTipoGenerica.filtroUts[x.campo];

                }

                item['uts'] = { ...item['uts'], [`${x.campo}`]: newVal }
            }
        });

        return item;

    }

    const onSelectedItem = (e, metadataRef) => {

        console.log("onSelectedItem", e);

        let _genericaSistema = { ...genericaSistema };

        const val = e['uts'][`${metadataRef.refCampoTg}`] || '';
        const ValText = Object.keys(e['uts']).includes(`ctiTexto${metadataRef.refCampoTg}`) ? e['uts'][`ctiTexto${metadataRef.refCampoTg}`] : e['uts']["ctiTexto"] || "";

        if (1 === 1) {
            //if (_genericaSistema['uts'][`${metadataRef.campo}`] !== val) {

            let afectacionExtraSeleccionRef = "";
            let obj = {};

            afectacionExtraSeleccionRef = metadataRef.afectacionExtraSeleccionRef;

            if (afectacionExtraSeleccionRef !== undefined && afectacionExtraSeleccionRef !== "") {
                //afectacionExtraSeleccionRef = afectacionExtraSeleccionRef.replace(" ", "");
                let splitAfectaciones = afectacionExtraSeleccionRef.split("=>");
                if (splitAfectaciones.length == 2) {
                    splitAfectaciones[0] = splitAfectaciones[0].replace("(", "").replace(")", "");
                    splitAfectaciones[1] = splitAfectaciones[1].replace("(", "").replace(")", "");
                    let camposExpresionesOrigen = splitAfectaciones[0].split(",");
                    let camposDependientes = splitAfectaciones[1].split(",");
                    if (camposExpresionesOrigen.length === camposDependientes.length) {

                        let keysUtsGenericaSistema = Object.keys(_genericaSistema.uts);
                        let keysUtsE = Object.keys(e.uts);

                        for (let i = 0; i < camposDependientes.length; i++) {
                            console.log("dfdfdfd, ", Object.keys(_genericaSistema).includes(camposDependientes[i]));
                            if (keysUtsGenericaSistema.includes(camposDependientes[i])) {

                                if (keysUtsE.includes(camposExpresionesOrigen[i])) {
                                    _genericaSistema.uts[camposDependientes[i]] = e.uts[camposExpresionesOrigen[i]];
                                }
                                else {
                                    console.log("ExpresionesOrigen no soportado aún");
                                }

                            }
                        }

                    }
                }
            }

            //----

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistemaForm];
            let metadata = undefined;
            let newMetada = undefined;
            let valAnt = undefined;

            for (let index in metadataGenericaSistemaForm) {
                metadata = metadataGenericaSistemaForm[index];

                if (metadata.campo === metadataRef.campo) {

                    _genericaSistema['uts'][`ctiTexto${metadataRef.campo}`] = ValText;

                    valAnt = _genericaSistema['uts'][`${metadataRef.campo}`];
                    _genericaSistema['uts'][`${metadataRef.campo}`] = val;
                    newMetada = generarValidadoresMetadata(metadata, val);

                    if (val !== valAnt) {
                        // aqui es para las campos disparadores
                        let dd = "";
                    }

                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                    setGenericaSistema(_genericaSistema);

                    console.log("metadata, ", metadata, ", metadataRef.formRef,", metadataRef.formRef);

                    let mtRef = metadataRef.formRef || metadata.formRef;
                    let mtRefIsRef = metadataRef.formRef !== undefined;
                    let indexCloseButton = metadataRef.formRef ? 0 : 1;

                    if (mtRef) {

                        if (mtRef.hide) {
                            mtRef.hide();
                        }
                        else {
                            let formRef = mtRef.getElement();

                            let botonClose = formRef.children[indexCloseButton];

                            if (mtRefIsRef) {
                                botonClose = botonClose.children[1];
                            }


                            if (botonClose.click)
                                botonClose.click();
                        }
                    }

                    break;

                }
                else {
                    newMetada = metadata;



                }

            }

            setMetadataGenericaSistemaForm(newMetadataGenericaSistemaForm);

        }
        else if (metadataRef.formRef) {

            if (metadataRef.formRef) {
                metadataRef.formRef.hide();
            }
            else {
                let formRef = metadataRef.formRef.getElement();
                let botonClose = formRef.children[0].children[1];
                if (botonClose.click)
                    botonClose.click();
            }

            /*
            if (metadataRef.formRef.getElement().close) {
                metadataRef.formRef.getElement().close();
            }
            
            else if (metadataRef.formRef.getElement().hide)
                metadataRef.formRef.getElement().hide();*/
        }


    }

    const onSelectedItemes = (e, metadataRef) => {

        console.log("onSelectedItemes", e);

        let val = "";
        let ValText = "";

        let _genericaSistema = { ...genericaSistema };

        for (let indexitem in e) {
            val = val + "," + e[indexitem]['uts'][`${metadataRef.refCampoTg}`];
            ValText = ValText + ", " + (Object.keys(e[indexitem]['uts']).includes(`ctiTexto${metadataRef.refCampoTg}`) ? e[indexitem]['uts'][`ctiTexto${metadataRef.refCampoTg}`] : e[indexitem]['uts']["ctiTexto"]);
        }
        if (val.length > 0)
            val = val.substring(1, val.length);

        if (ValText.length > 0)
            ValText = ValText.substring(2, ValText.length);

        if (1 === 1) {
            //if (_genericaSistema['uts'][`${metadataRef.campo}`] !== val) {

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistemaForm];
            let metadata = undefined;
            let newMetada = undefined;
            let valAnt = undefined;

            for (let index in metadataGenericaSistemaForm) {
                metadata = metadataGenericaSistemaForm[index];

                if (metadata.campo === metadataRef.campo) {

                    _genericaSistema['uts'][`ctiTexto${metadataRef.campo}`] = ValText;

                    valAnt = _genericaSistema['uts'][`${metadataRef.campo}`];
                    _genericaSistema['uts'][`${metadataRef.campo}`] = val;
                    newMetada = generarValidadoresMetadata(metadata, val);

                    if (val !== valAnt) {
                        // aqui es para las campos disparadores
                        let dd = "";
                    }

                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                    setGenericaSistema(_genericaSistema);

                    console.log("metadata, ", metadata, ", metadataRef.formRef,", metadataRef.formRef);

                    if (metadataRef.formRef) {

                        if (metadataRef.formRef) {
                            if (metadataRef.formRef.hide)
                                metadataRef.formRef.hide();
                        }
                        else {
                            let formRef = metadataRef.formRef.getElement();
                            let botonClose = formRef.children[0].children[1];
                            if (botonClose.click)
                                botonClose.click();
                        }

                        /*
                        if (metadataRef.formRef.getElement().close) {
                            metadataRef.formRef.getElement().close();
                        }
                        
                        else if (metadataRef.formRef.getElement().hide)
                            metadataRef.formRef.getElement().hide();*/
                    }

                    break;

                }
                else {
                    newMetada = metadata;



                }

            }

            setMetadataGenericaSistemaForm(newMetadataGenericaSistemaForm);

        }
        else if (metadataRef.formRef) {

            if (metadataRef.formRef) {
                metadataRef.formRef.hide();
            }
            else {
                let formRef = metadataRef.formRef.getElement();
                let botonClose = formRef.children[0].children[1];
                if (botonClose.click)
                    botonClose.click();
            }

            /*
            if (metadataRef.formRef.getElement().close) {
                metadataRef.formRef.getElement().close();
            }
            
            else if (metadataRef.formRef.getElement().hide)
                metadataRef.formRef.getElement().hide();*/
        }


    }

    /*
    console.log("dfdf", val, ValText);
    if (metadataGenericaSistemaForm.find(x => x.campo === metadataRef.campo)) {
        _genericaSistema['uts'][`${metadataRef.campo}`] = val;
        _genericaSistema['uts'][`ctiTexto${metadataRef.campo}`] = ValText;
    }
    else
        _genericaSistema[`${metadataRef.campo}`] = val;
    
    console.log("metadataRef, ", val, ValText);
    setGenericaSistema(_genericaSistema);
    if (metadataRef.formRef.close)
        metadataRef.formRef.close();
    else if (metadataRef.formRef.hide)
        metadataRef.formRef.hide();
    
    
    }*/

    const onDocumentChange = (genericasSistemaAffected, metadataRef) => {

        console.log("dc", genericasSistemaAffected, metadataRef);
        //genericasSistemaAffected[0].uts["guid"];
        let _genericaSistema = { ...genericaSistema };

        let genericaSistemaAffected = genericasSistemaAffected[0];

        const val = genericaSistemaAffected['uts'][`${metadataRef.refCampoTg}`] || '';
        const valguid = Object.keys(genericaSistemaAffected['uts']).includes(`guid`) ? genericaSistemaAffected['uts'][`guid`] : "";
        const valguidAnt = _genericaSistema['uts'][`guid${metadataRef.campo}`] || "";

        if (valguidAnt !== valguid) {

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistemaForm];
            let metadata = undefined;
            let newMetada = undefined;

            for (let index in metadataGenericaSistemaForm) {
                metadata = metadataGenericaSistemaForm[index];

                if (metadata.campo === metadataRef.campo) {

                    _genericaSistema['uts'][`${metadataRef.campo}`] = val;
                    _genericaSistema['uts'][`guid${metadataRef.campo}`] = valguid;

                    newMetada = generarValidadoresMetadata(metadata, val);
                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                    setGenericaSistema(_genericaSistema);

                    console.log("metadata, ", metadata, ", metadataRef.formRef,", metadataRef.formRef);

                    if (metadataRef.formRef) {
                        let formRef = metadataRef.formRef.getElement();
                        let botonClose = formRef.children[0].children[1];
                        if (botonClose.click)
                            botonClose.click();
                        /*if (formRef.close) {
                            formRef.close();
                        }
                        else if (metadataRef.formRef.getElement().hide)
                            formRef.hide();
                        */
                    }

                    break;

                }
                else { newMetada = metadata; }

            }

            setMetadataGenericaSistemaForm(newMetadataGenericaSistemaForm);

        }

    }


    const onBooleanChange = (e, campo, reFsGenericaSistemaBase) => {


        let genericaSistemaBase = genericaSistema;
        let setterGenericaBase = setGenericaSistema;
        let metadataGenericaSistema = metadataGenericaSistemaForm;
        let setterMetadataGenericaSistema = setMetadataGenericaSistemaForm;


        if (reFsGenericaSistemaBase !== undefined) {
            genericaSistemaBase = reFsGenericaSistemaBase.genericaSistemaBase;
            setterGenericaBase = reFsGenericaSistemaBase.setterGenericaBase;

            metadataGenericaSistema = reFsGenericaSistemaBase.metadataGenericaBase;
            setterMetadataGenericaSistema = reFsGenericaSistemaBase.setterMetadataGenericaBase;

        }

        const val = (e.checked && e.checked) || false;

        let _genericaSistema = { ...genericaSistemaBase };

        console.log("onBooleanChange, ", _genericaSistema);

        if (_genericaSistema['uts'][`${campo}`] !== val) {

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistema];
            let metadata = undefined;
            let newMetada = undefined;

            for (let index in newMetadataGenericaSistemaForm) {
                metadata = newMetadataGenericaSistemaForm[index];
                if (metadata.campo === campo) {

                    _genericaSistema['uts'][`${campo}`] = val;
                    newMetada = generarValidadoresMetadata(metadata, val, genericaSistemaBase);
                    newMetada.formRef = metadata.formRef;

                    newMetadataGenericaSistemaForm[index] = newMetada;

                    setterGenericaBase(_genericaSistema);
                    break;

                }
                else { newMetada = metadata; }

                //newMetadataGenericaSistemaForm.push(newMetada);

            }

            setterMetadataGenericaSistema(newMetadataGenericaSistemaForm);

        }

    }

    const parseDateTime = (text, metadata) => {

        console.log("text, ", text, text.length, "metadata,", metadata);

        if (metadata.formatoDato === "date") {

            if (text.length < 10)
                return null;

            let splitText = text.split('/');
            if (splitText.length !== 3)
                return null;

            //var timeTexto = Date.parse(text);
            //var dt = new Date(timeTexto);

            let newTextDate = splitText[2] + "-" + splitText[1] + "-" + splitText[0] + "T10:00:00Z";  //'2023-01-15T10:30:00Z'
            let specificDate = new Date(newTextDate);
            let isValid = !isNaN(specificDate.getTime());

            if (isValid) {
                return specificDate;
            }
            else {
                return null;
            }
        }
        else {//Por default es datetime

            //26/06/2025 07:50 AM
            if (text.length < 19)
                return null;

            let splitTextDatetime = text.split(' ');
            if (splitTextDatetime.length !== 3)
                return null;

            let splitTextDate = splitTextDatetime[0].split('/');
            if (splitTextDate.length !== 3)
                return null;

            let splitTextTime = splitTextDatetime[1].split(':');

            //var timeTexto = Date.parse(text);
            //var dt = new Date(timeTexto);

            let newTextDate = splitTextDate[2] + "-" + splitTextDate[1] + "-" + splitTextDate[0] + "T" + splitTextTime[0] + ":" + splitTextTime[1] + ":00Z";  //'2023-01-15T10:30:00Z'
            let specificDate = new Date(newTextDate);
            let isValid = !isNaN(specificDate.getTime());

            if (isValid) {
                return specificDate;
            }
            else {
                return null;
            }

        }

    }

    const onCalendarChange = (e, campo, _genericaSistemaBase, _setterGenericaBase) => {

        let genericaSistemaBase = _genericaSistemaBase || genericaSistema;
        let setterGenericaBase = _setterGenericaBase || setGenericaSistema;

        //let val = e.value || (e.target && e.target.value) || e.htmlValue || e.originalEvent.currentTarget.value || null;
        // la forma es diferente por ser un tipo calendar
        let val = e.value || (e.target && e.target.value) || null;
        let valTexto = e.htmlValue || e.originalEvent.currentTarget.value || '';

        console.log("valTexto ", e.htmlValue, e.originalEvent.currentTarget.value, valTexto);

        let _genericaSistema = { ...genericaSistemaBase };

        //if (_genericaSistema['uts'][`${campo}`] !== val) {

        let newMetadataGenericaSistemaForm = [...metadataGenericaSistemaForm];
        let metadata = undefined;
        let newMetada = undefined;

        let valAnt = _genericaSistema['uts'][`${campo}`];
        let refrescaMetadata = !(valAnt !== null && val === null);

        for (let index in newMetadataGenericaSistemaForm) {
            metadata = newMetadataGenericaSistemaForm[index];
            if (metadata.campo === campo) {

                /*
                if (valTexto.length > 9) {
                    var timeTexto = Date.parse(valTexto);
                    var dt = new Date(timeTexto);

                    if (timeTexto > 0) {
                        val = dt;
                    }

                }*/

                console.log("eve, ", val, " valor anterior: ", _genericaSistema['uts'][`${campo}`], " valorTexto, ", valTexto);

                //val = dt;


                //if (_genericaSistema['uts'][`${campo}`] !== val) {

                _genericaSistema['uts'][`${campo}`] = val;

                //if (refrescaMetadata) {
                newMetada = generarValidadoresMetadata(metadata, val);
                newMetada.formRef = metadata.formRef;
                newMetadataGenericaSistemaForm[index] = newMetada;
                //}

                setGenericaSistema(_genericaSistema);

                //}

                break;

            }
            else { newMetada = metadata; }

            //newMetadataGenericaSistemaForm.push(newMetada);
        }

        //            if (refrescaMetadata) {
        setMetadataGenericaSistemaForm(newMetadataGenericaSistemaForm);
        //          }

        //}

    }

    const onInputChange = (e, campo, reFsGenericaSistemaBase) => {


        let genericaSistemaBase = genericaSistema;
        let setterGenericaBase = setGenericaSistema;
        let metadataGenericaSistema = metadataGenericaSistemaForm;
        let setterMetadataGenericaSistema = setMetadataGenericaSistemaForm;


        if (reFsGenericaSistemaBase !== undefined) {
            genericaSistemaBase = reFsGenericaSistemaBase.genericaSistemaBase;
            setterGenericaBase = reFsGenericaSistemaBase.setterGenericaBase;

            metadataGenericaSistema = reFsGenericaSistemaBase.metadataGenericaBase;
            setterMetadataGenericaSistema = reFsGenericaSistemaBase.setterMetadataGenericaBase;

        }

        const val = (e.target && e.target.value) || e.htmlValue || '';
        let _genericaSistema = { ...genericaSistemaBase };

        if (_genericaSistema['uts'][`${campo}`] !== val) {

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistema];
            let metadata = undefined;
            let newMetada = undefined;

            for (let index in newMetadataGenericaSistemaForm) {
                metadata = newMetadataGenericaSistemaForm[index];
                if (metadata.campo === campo) {

                    _genericaSistema['uts'][`${campo}`] = val;
                    newMetada = generarValidadoresMetadata(metadata, val, genericaSistemaBase);
                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                    setterGenericaBase(_genericaSistema);
                    break;

                }
                else { newMetada = metadata; }
                //newMetadataGenericaSistemaForm.push(newMetada);

            }

            setterMetadataGenericaSistema(newMetadataGenericaSistemaForm);

        }

    }

    const onInputTextChange = (e, campo, reFsGenericaSistemaBase) => {
        console.log("onInputTextChange", e, campo);

        let val = (e.target && e.target.value) || e.htmlValue || e || '';

        let genericaSistemaBase = genericaSistema;
        let setterGenericaBase = setGenericaSistema;
        let metadataGenericaSistema = metadataGenericaSistemaForm;
        let setterMetadataGenericaSistema = setMetadataGenericaSistemaForm;


        if (reFsGenericaSistemaBase !== undefined) {
            genericaSistemaBase = reFsGenericaSistemaBase.genericaSistemaBase;
            setterGenericaBase = reFsGenericaSistemaBase.setterGenericaBase;

            metadataGenericaSistema = reFsGenericaSistemaBase.metadataGenericaBase;
            setterMetadataGenericaSistema = reFsGenericaSistemaBase.setterMetadataGenericaBase;

        }

        let _genericaSistema = { ...genericaSistemaBase };

        if (_genericaSistema['uts'][`${campo}`] !== val) {

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistema];

            let metadata = undefined;
            let newMetada = undefined;

            for (let index in newMetadataGenericaSistemaForm) {
                metadata = newMetadataGenericaSistemaForm[index];
                if (metadata.campo === campo) {

                    _genericaSistema['uts'][`${campo}`] = val;


                    newMetada = generarValidadoresMetadata(metadata, val, genericaSistemaBase);
                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                    setterGenericaBase(_genericaSistema);

                    //break;


                }
                else if (metadata.tipoDato === "text") {

                    newMetada = generarValidadoresMetadata(metadata, _genericaSistema['uts'][`${metadata.campo}`], genericaSistemaBase);
                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                }
                else { newMetada = metadata; }

                //newMetadataGenericaSistemaForm.push(newMetada);

            }

            //setTimeout(() => {

            setterMetadataGenericaSistema(newMetadataGenericaSistemaForm);

            //}, 1);

        }

    }

    const onInputTextChange22 = (e, campo) => {
        console.log("onInputTextChange", e, campo);

        let val = (e.target && e.target.value) || e.htmlValue || e || '';

        let _genericaSistema = { ...genericaSistema };

        if (_genericaSistema['uts'][`${campo}`] !== val) {

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistemaForm];

            let metadata = undefined;
            let newMetada = undefined;

            for (let index in newMetadataGenericaSistemaForm) {
                metadata = newMetadataGenericaSistemaForm[index];
                if (metadata.campo === campo) {

                    _genericaSistema['uts'][`${campo}`] = val;


                    newMetada = generarValidadoresMetadata(metadata, val);
                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                    setGenericaSistema(_genericaSistema);

                    //break;


                }
                else if (metadata.tipoDato === "text") {

                    newMetada = generarValidadoresMetadata(metadata, _genericaSistema['uts'][`${metadata.campo}`]);
                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                }
                else { newMetada = metadata; }

                //newMetadataGenericaSistemaForm.push(newMetada);

            }

            //setTimeout(() => {

            setMetadataGenericaSistemaForm(newMetadataGenericaSistemaForm);

            //}, 1);

        }

    }

    const onInputNumberChange = (e, campo) => {

        console.log("onInputNumberChange,");

        const val = e.value || 0;

        let _genericaSistema = { ...genericaSistema };

        if (_genericaSistema['uts'][`${campo}`] !== val) {

            let newMetadataGenericaSistemaForm = [...metadataGenericaSistemaForm];
            let metadata = undefined;
            let newMetada = undefined;

            for (let index in newMetadataGenericaSistemaForm) {
                metadata = newMetadataGenericaSistemaForm[index];
                if (metadata.campo === campo) {

                    _genericaSistema['uts'][`${campo}`] = val;
                    newMetada = generarValidadoresMetadata(metadata, val);
                    newMetada.formRef = metadata.formRef;
                    newMetadataGenericaSistemaForm[index] = newMetada;

                    setGenericaSistema(_genericaSistema);
                    break;


                }
                else { newMetada = metadata; }
                //newMetadataGenericaSistemaForm.push(newMetada);
            }

            setMetadataGenericaSistemaForm(newMetadataGenericaSistemaForm);


        }

    }

    useEffect(() => {

        if (genericaSistemaDialog && metadataGenericaSistemaForm.length > 0) {
            setTimeout(() => {

                let tieneFoco = false;
                let comodin = "";
                for (let i in metadataGenericaSistemaForm) {

                    let primerCampo = metadataGenericaSistemaForm[i];

                    switch (primerCampo.tipoDato) {
                        case "date": console.log("asdfasfas, ", primerCampo.formRef); break;
                        case "ref": break;
                        case "label": break;
                        case "file": break;
                        case "boolean": if (primerCampo.formRef) { primerCampo.formRef.getElement().focus(); tieneFoco = true; } break;
                        default: if (primerCampo.formRef) {
                            primerCampo.formRef && primerCampo.formRef.inputRef ? (primerCampo.formRef.inputRef.current.focus) ? primerCampo.formRef.inputRef.current.focus() : comodin = "" : (primerCampo.formRef.focus) ? primerCampo.formRef.focus() : comodin = "";
                            tieneFoco = true;
                            break;
                        }
                        else break;

                    }

                    if (tieneFoco)
                        break;

                }


            }, 100);

        }

    }, [genericaSistemaDialog]);





    const renderHeaderTemplateEditor = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );

    }

    const headerTemplateEditor = renderHeaderTemplateEditor();

    const generarCamposFormularioGenericaSistemaSeleccionada = () => {

        let metadatafiltered = [];

        if (genericaSistema.id <= 0) {
            metadatafiltered = metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false && (x.requeridoParaNuevo === true));
        }
        else {
            metadatafiltered = metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false && (x.actualizableEnFormulario === true));
        }

        //console.log("metadatafiltered, ",metadatafiltered);

        return metadatafiltered.map((metadata, index, array) => {

            if (metadata.tipoDato === "sequence" || (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(metadata.campo))) {
                return (<></>);

            }

            else {

                let classNameFlex = "flex-1 md:flex-none";
                switch (metadata.tipoDato) {
                    case "boolean":
                        classNameFlex = metadata.formatoDato !== "aceptaTerminos" ? "col-12 md:col-6 lg:col-3" : "col-12";
                        break;
                    case "ref": classNameFlex = "col-12 md:col-6 lg:col-3"; break;
                    case "text": classNameFlex = "col-12"; break;
                    case "captcha": classNameFlex = "col-12"; break;
                    default: classNameFlex = "col-12 md:col-6 lg:col-3";
                }

                return (<>
                    <div className={classNameFlex}>
                        {generarDescripcionCampo(metadata)}
                        <div className='flex lg:align-items-start'>
                            {generarCampo(metadata)}
                        </div>

                    </div>

                </>);
            }
        });

    }

    const generarDescripcionCampo = (metadata) => {

        if (metadata) {

            if (!metadata.ctiTextoDesc) {
                return (
                    <>
                        <label className='flex align-items-start' id={`label${metadata.tg}-${metadata.campo}`}>{metadata.ctiTexto} {generarInformacionComplementariaCampo(metadata)} </label>
                    </>
                );
            }
            else if (metadata.ctiTextoDesc && metadata.ctiTextoDescVisibilidad === "VISIBLE_BEFORE") {
                return (
                    <>
                        <label className='flex align-items-start' id={`label${metadata.tg}-${metadata.campo}`}> {generarInformacionComplementariaCampo(metadata)} </label>
                        <div className='justify-content-around' style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: metadata.ctiTextoDesc }} />
                        {metadata.ctiTexto}
                    </>
                );
            }
            else
                return (
                    <>
                        <label id={`label${metadata.tg}-${metadata.campo}`}>{metadata.ctiTexto} {generarInformacionComplementariaCampo(metadata)} </label>
                        <div style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: metadata.ctiTextoDesc }} />
                    </>
                );

        }
        else return (<></>);

    }

    const generarInformacionComplementariaCampo = (metadata) => {

        //let refTg = { "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto };

        //<Chip label="2 de 100" />
        return (<>
            {
                (function () {
                    if (metadata.esRequerido) {
                        return (<Tag className="mr-2" icon="pi pi-info-circle" severity="info" value=""></Tag>);
                    }
                    else {
                        return (<></>);
                    }
                })()

            }

            {
                (function () {
                    if (metadata.tipoDato === "int" || metadata.tipoDato === "double" || metadata.tipoDato === "money") {
                        if (metadata.valMin !== undefined && metadata.valMin >= metadata.valEval) {
                            return (<Chip label={`Mayor o igual a ${metadata.valMin}`} />);
                        }
                        else if (metadata.valMax !== undefined && metadata.valMax <= metadata.valEval) {
                            return (<Chip label={`Menor o igual que ${metadata.valMax}`} />);
                        }

                    }
                    else if (metadata.tipoDato === "date") {
                        if (metadata.valMin !== undefined && metadata.valMin >= metadata.valEval) {
                            return (<Chip label={`Mayor o igual que ${metadata.valMin}`} />);
                        }
                        else if (metadata.valMax !== undefined && metadata.valMax <= metadata.valEval) {
                            return (<Chip label={`Menor o igual que ${metadata.valMax}`} />);
                        }

                    }
                    else if (metadata.tipoDato === "text") {

                        if (metadata.valMin !== undefined && metadata.valMin >= metadata.valEval) {
                            return (<><Chip label={`${metadata.valEval} de mínimo ${metadata.valMin} palabra(s).`} /></>);
                        }
                        else if (metadata.valMax !== undefined && metadata.valMax <= metadata.valEval) {
                            return (<><Chip label={`${metadata.valEval} de ${metadata.valMax} palabras`} /></>);
                        }
                    }
                    else if (metadata.tipoDato === "string") {
                        if (metadata.valMin !== undefined && metadata.valMin >= metadata.valEval) {
                            return (<><Chip label={`${metadata.valEval} de mínimo ${metadata.valMin} letras(s).`} /></>);
                        }
                        else if (metadata.valMax !== undefined && metadata.valMax <= metadata.valEval) {
                            return (<><Chip label={`${metadata.valEval} de ${metadata.valMax} letras máximo`} /></>);
                        }
                    }
                })()
            }
        </>);

    }

    const generarCamposConfirmacionOPT = () => {

        console.log("metadataGenericaSistemaConfirmacionOpt, ", metadataGenericaSistemaConfirmacionOpt);
        let metadatafiltered = [];

        if (genericaSistema.id <= 0) {
            metadatafiltered = metadataGenericaSistemaConfirmacionOpt.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false && (x.requeridoParaNuevo === true))
        }
        else {
            metadatafiltered = metadataGenericaSistemaConfirmacionOpt.filter(x => x.tipoDato !== "label" && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false && (x.actualizableEnFormulario === true))
        }

        return metadatafiltered.map((metadata, index, array) => {

            if (metadata.tipoDato === "sequence" || (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(metadata.campo))) {
                return (<></>);

            }

            else {

                let refsGenericaBase = {
                    genericaSistemaBase: genericaSistemaConfirmacionOpt,
                    setterGenericaBase: setGenericaSistemaConfirmacionOpt,
                    metadataGenericaBase: metadataGenericaSistemaConfirmacionOpt,
                    setterMetadataGenericaBase: setMetadataGenericaSistemaConfirmacionOpt
                };

                return (<>
                    <div className="field  col-12 lg:col-5">
                        {generarDescripcionCampo(metadata)}
                        <div className='flex lg:align-items-start'>
                            {generarCampo(metadata, refsGenericaBase)}
                        </div>

                    </div>

                </>);
            }
        });

    }

    const config = useMemo(() => ({
        //uploader: {insertImageAsBase64URI: true,imagesExtensions: ['jpg', 'png', 'jpeg', 'gif', 'svg', 'webp']},
        //placeholder:"start typing....",
        "useSearch": false,
        "toolbarAdaptive": false,
        "toolbarSticky": false,
        "showXPathInStatusbar": false,
        "showCharsCounter": false,
        "showWordsCounter": false,
        "disablePlugins": "image,image-processor,image-properties,drag-and-drop,drag-and-drop-element",
        "minHeight": 300, "height": 300,
        //"inline": true,
        "toolbarInlineForSelection": true,
        "showPlaceholder": false,
        "buttons": "bold,italic,underline,strikethrough,eraser,ul,ol,font,fontsize,paragraph,lineHeight,superscript,subscript,file,image,video, table, link, align,  hr, , eraser, copyformat,symbol,spellcheck,speechRecognize,cut"
    }), []);

    const showResponse = () => {
        toast.current.show({ severity: 'info', summary: 'Success', detail: 'User Responded' });
    }

    const selectButtonBodyItemTemplate = (option) => {
        //console.log("option,", option);

        let campoCtiTextoOptionsSelectButton = 'ctiTexto';

        return <div className="m-0" dangerouslySetInnerHTML={{ __html: option.uts[campoCtiTextoOptionsSelectButton] }} />
        //return <i className={option.icon}></i>;
    }

    const DynamicEditor = dynamic(
        () => import('primereact/editor').then((mod) => mod.Editor),
        { ssr: false }
    );


    const generarCampo = (metadata, reFsGenericaSistemaBase) => {

        let genericaSistemaBase = genericaSistema;
        let setterGenericaBase = setGenericaSistema;
        let metadatagenericaSistemaBaseFormBase = metadataGenericaSistemaForm;
        let setterMetadataGenericaSistema = setMetadataGenericaSistemaForm;


        if (reFsGenericaSistemaBase !== undefined) {
            genericaSistemaBase = reFsGenericaSistemaBase.genericaSistemaBase;
            setterGenericaBase = reFsGenericaSistemaBase.setterGenericaBase;

            metadatagenericaSistemaBaseFormBase = reFsGenericaSistemaBase.metadataGenericaBase;
            setterMetadataGenericaSistema = reFsGenericaSistemaBase.setterMetadataGenericaBase;

        }

        let val = genericaSistemaBase['uts'][`${metadata.campo}`];

        let modeNumeric = "decimal";
        let minFractionDigits = 0;
        let maxFractionDigits = 0;

        let classNameInput = "w-full  p-component " + classNames({ 'p-invalid': !metadata.valido && metadata.ingresado });

        console.log("generarCampoFormulario", metadata.tipoDato, metadata.valido, classNameInput);

        switch (metadata.tipoDato) {
            case "boolean":

                val = (val === undefined) ? false : ((typeof val === "boolean") ? val : val.toLowerCase() === "true");
                return (
                    <Checkbox id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                        checked={val} ref={e => metadata.formRef = e}
                        onChange={(e) => onBooleanChange(e, metadata.campo, reFsGenericaSistemaBase)}
                        className={classNameInput} ></Checkbox>
                );
            case "int":

                if (metadata.formatoDato === "money") {
                    modeNumeric = "currency";
                    minFractionDigits = 0;
                    maxFractionDigits = 0;

                    return (<InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                        mode={modeNumeric} currency="COP" locale="es-CO"
                        value={val} ref={e => metadata.formRef = e}
                        onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)}
                        className={classNameInput} min={metadata.valMin} max={metadata.valMax} showButtons />);


                }

                return (<InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} mode={modeNumeric} value={val} ref={e => metadata.formRef = e}
                    onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)}
                    className={classNameInput} min={metadata.valMin} max={metadata.valMax} showButtons />);

            case "double":

                if (metadata.formatoDato === "money") {
                    modeNumeric = "currency";
                    minFractionDigits = 0;
                    maxFractionDigits = 0;
                }


                return (<><InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} mode={modeNumeric} value={val} ref={e => metadata.formRef = e}
                    onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} min={metadata.valMin} max={metadata.valMax} minFractionDigits={minFractionDigits} maxFractionDigits={maxFractionDigits} locale="es-CO" showButtons />
                </>);
            case "money":
                return (<InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} mode="currency" value={val} ref={e => metadata.formRef = e}
                    onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);
            case "sequence": return (<InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} readOnly value={val} ref={e => metadata.formRef = e}
                onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);
            case "double": return (<InputNumber id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} mode="decimal" value={val} ref={e => metadata.formRef = e}
                onValueChange={(e) => onInputNumberChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);
            case "text1":

                return (

                    <div className={classNameInput}>
                        <JoditEditor
                            //translate='no' style={{ height: '40rem' }}
                            value={val} ref={e => metadata.formRef = e}

                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            //onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                            onChange={(newContent) => { onInputTextChange(newContent, metadata.campo); return false; }}
                        />
                    </div>


                );

            case "text": return (
                <div className={classNameInput} >
                    <Editor translate='no' key={`fieldEdit${metadata.tg}-${metadata.campo}`} id={`fieldEdit${metadata.tg}-${metadata.campo}`} className={classNameInput} style={{ height: '10rem' }}
                        aria-labelledby={`label${metadata.tg}-${metadata.campo}`} headerTemplate={headerTemplateEditor}
                        value={val || ""} ref={e => metadata.formRef = e}

                        onLoad={(quill) => {
                            if (quill && val) {
                                quill.clipboard.dangerouslyPasteHTML(val);
                            }
                        }}
                        onTextChange={(e) => { onInputTextChange(e, metadata.campo, reFsGenericaSistemaBase) }} />
                </div>

            );

            case "text2": return (<InputTextarea id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} value={val} ref={e => metadata.formRef = e} onChange={(e) => onInputChange(e, metadata.campo, reFsGenericaSistemaBase)}
                className={classNameInput} />);



            case "date":

                if (metadata.formatoDato == "date") {
                    return (<Calendar id={`fieldEdit${metadata.tg}-${metadata.campo}`} ref={e => metadata.formRef = e}
                        value={val}
                        dateFormat="dd/mm/yy"
                        aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                        className={classNameInput}
                        onChange={(e) => onCalendarChange(e, metadata.campo)}
                        required
                        showButtonBar
                        keepInvalid={true}
                        parseDateTime={(text) => parseDateTime(text, metadata)}
                        readOnlyInput={false}
                        showIcon
                    />);

                }
                else {
                    return (<Calendar id={`fieldEdit${metadata.tg}-${metadata.campo}`} ref={e => metadata.formRef = e}
                        value={val}
                        dateFormat="dd/mm/yy"
                        aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                        className={classNameInput}
                        onChange={(e) => onCalendarChange(e, metadata.campo, reFsGenericaSistemaBase)}
                        required
                        showButtonBar
                        showTime
                        hourFormat="12"
                        keepInvalid={true}
                        parseDateTime={(text) => parseDateTime(text, metadata)}
                        readOnlyInput={false}
                        showIcon
                    />);
                }


            case "date5":
                console.log("date, ", val);
                return (<Calendar id="buttondisplay"
                    value={val}
                    onChange={(e) => { onCalendarChange(e, metadata.campo) }}
                    dateFormat="dd/mm/yy"
                    ref={e => metadata.formRef = e}
                    showButtonBar
                    required
                    keepInvalid={true}
                    parseDateTime={parseDateTime}
                    readOnlyInput={false}
                    showIcon />
                );


            case "date2":

                return (<Calendar id={`fieldEdit${metadata.tg}-${metadata.campo}`} showButtonBar showTime readOnlyInput={false} hourFormat="12" showIcon dateFormat="dd/mm/yy" aria-labelledby={`label${metadata.tg}-${metadata.campo}`} value={val} ref={e => metadata.formRef = e} required
                    onChange={(e) => onCalendarChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);

            case "date2":
                return (<Calendar showButtonBar readOnlyInput={false} showIcon dateFormat="dd/mm/yy" id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} value={val} ref={e => metadata.formRef = e} required
                    onChange={(e) => onCalendarChange(e, metadata.campo, reFsGenericaSistemaBase)} className={classNameInput} />);

            case "color": return (<ColorPicker onChange={(e) => onInputChange(e, metadata.campo, reFsGenericaSistemaBase)} id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`} value={val} ref={e => metadata.formRef = e} required className={classNameInput} />);

            case "ref":

                let valRef = genericaSistemaBase['uts'][`${"ctiTexto" + metadata.campo}`];
                let metadataRef = { ...metadata }

                valRef = htmlToText(valRef);

                //console.log("metadata, ", metadata, "genericaSistemaBase,", selectedTipoGenerica);

                let refTg = {
                    "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto,
                    variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
                };
                let filtroUtsDominioDato = metadata.filtroUtsDominioDato || '';

                if (filtroUtsDominioDato.includes("[[INTERNO_")) {

                    metadatagenericaSistemaBaseFormBase.forEach(x => {

                        let campoInterno = `[[INTERNO_${x.campo}]]`;
                        if (metadata.campo !== x.campo && filtroUtsDominioDato.includes(campoInterno)) {

                            let valInterno = genericaSistemaBase['uts'][x.campo] || '';
                            filtroUtsDominioDato = filtroUtsDominioDato.replace(campoInterno, `'${valInterno}'`);
                            //console.log("ref listado, ", refTg, valRef, filtroUtsDominioDato);

                        }

                    });

                }




                /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                    refTg.tg = metadata.dominioDato;
                    evalValMin.includes("[[EXTERNO_")
                }*/

                if (selectedTipoGenerica.tg === "DMS_VSTA_REGISTRO_ACTA_ASISTENCIA_INVITADO_ATENCION_ESTUDIANTE" && optionsSelectButton !== undefined) {

                    console.log("metadata, ", metadata);

                    let tgSelectItem = "DMS_ACTA_ESCALA_SATISFACCION";
                    let items = [];
                    items = optionsSelectButton.filter(x => x.tg === tgSelectItem
                        //&& x.uts[campoCriterio] === valCriterio
                    ).map(x => ({ ...x, value: x.uts["escalaSatisfaccion"] + '', 'name': x.uts["ctiTexto"] }));

                    return <SelectButton value={val} optionLabel="name" itemTemplate={selectButtonBodyItemTemplate}
                        data-hola989898="adsfasf"
                        options={items}
                        onChange={(e) => onInputChange(e, metadata.campo, reFsGenericaSistemaBase)}

                        style={{ display: "flex" }}
                    ></SelectButton>

                }

                return (<div className={"tipoCampoRef " + classNameInput}>


                    <Button id={`bt${metadata.campo}`} type="button" icon="pi pi-search" label={valRef ? valRef || val : 'Seleccionar Opción'}
                        onClick={(e) => showOverlayPanel(e, `${metadata.campo}`)}
                        className="w-full  dropdown-fake" />

                    <OverlayPanel ref={e => metadata.formRef = e} showCloseIcon style={{ width: '80%', 'margin-top': '2%', 'margin-left': '2%' }} className="overlaypanel-demo">
                        <DataTableListGenerica selectedTipoGenerica={refTg}
                            onSelectedItem={onSelectedItem} metadataRef={metadataRef} etiquetasModulo={etiquetasModulo}
                            filtroUtsDominioDato={filtroUtsDominioDato} genericaSistemaBaseRef={genericaSistemaBase}
                        ></DataTableListGenerica>
                    </OverlayPanel>
                </div>);



            case "multivalue":

                if (val !== undefined)
                    val = val.replace(" ", "");

                let valRefMultivalue = genericaSistemaBase['uts'][`${"ctiTexto" + metadata.campo}`];

                valRefMultivalue = htmlToText(valRefMultivalue);

                console.log("metadata, ", metadata, "genericaSistemaBase,", selectedTipoGenerica);

                let refTgMultivalue = {
                    "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto,
                    variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
                };
                let filtroUtsDominioDatoMultivalue = metadata.filtroUtsDominioDato || '';

                if (filtroUtsDominioDatoMultivalue.includes("[[INTERNO_")) {

                    metadatagenericaSistemaBaseFormBase.forEach(x => {

                        let campoInterno = `[[INTERNO_${x.campo}]]`;
                        if (metadata.campo !== x.campo && filtroUtsDominioDatoMultivalue.includes(campoInterno)) {

                            let valInterno = genericaSistemaBase['uts'][x.campo] || '';
                            filtroUtsDominioDatoMultivalue = filtroUtsDominioDatoMultivalue.replace(campoInterno, `'${valInterno}'`);
                            //console.log("ref listado, ", refTg, valRef, filtroUtsDominioDato);

                        }

                    });




                }

                /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                    refTg.tg = metadata.dominioDato;
                    evalValMin.includes("[[EXTERNO_")
                }*/


                return (<div ref={e => metadata.formRef = e} className={classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })}>


                    <DataTableListGenerica selectionMode="multivalue" initialSelectedItemes={val} selectedTipoGenerica={refTgMultivalue}
                        onSelectedItemes={onSelectedItemes} metadataRef={metadata} etiquetasModulo={etiquetasModulo}
                        filtroUtsDominioDato={filtroUtsDominioDatoMultivalue} genericaSistemaBaseRef={genericaSistemaBase}
                    ></DataTableListGenerica>
                </div>);

            case "ref2":

                const valRef2 = genericaSistemaBase['uts'][`${"ctiTexto" + metadata.campo}`];
                let refTg2 = { "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto };
                /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                    refTg.tg = metadata.dominioDato;
                }*/

                return (<Inplace closable ref={e => metadata.formRef = e} style={{ width: '95%' }} className={classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })} >
                    <InplaceDisplay>
                        {valRef2 || val} || 'Click para editar'
                    </InplaceDisplay>
                    <InplaceContent>
                        <DataTableListGenerica selectedTipoGenerica={refTg2} onSelectedItem={onSelectedItem} metadataRef={metadata} etiquetasModulo={etiquetasModulo}></DataTableListGenerica>
                    </InplaceContent>
                </Inplace>);

            case "refDep":

                const valRef3 = genericaSistemaBase['uts'][`${"ctiTexto" + metadata.campo}`];
                let refTg3 = { "tg": metadata.formatoDato, "cti": "TG-SYS-ACA_UNIDAD", "ctiTexto": metadata.ctiTexto };
                /*if (metadata.dominioDato !== null && metadata.dominioDato !== "") {
                    refTg.tg = metadata.dominioDato;
                }*/

                return (<div className={classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })}>
                    <Button id={`bt${metadata.campo}`} type="button" icon="pi pi-search" label={valRef3 ? valRef3 || val : 'Click para editar'} ref={e => metadata.formRef = e} style={{ width: '30%', minWidth: '10rem' }} onClick={(e) => showOverlayPanel(e, `${metadata.campo}`)} aria-haspopup aria-controls="overlay_panel" className="select-product-button" />
                    <OverlayPanel ref={e => metadata.formRef = e} showCloseIcon style={{ width: '25rem', 'margin-top': '5%', 'margin-left': '5%' }} className="overlaypanel-demo">
                        <DataTableListGenerica selectedTipoGenerica={refTg} onSelectedItem={onSelectedItem} metadataRef={metadata} etiquetasModulo={etiquetasModulo}></DataTableListGenerica>
                    </OverlayPanel>
                </div>);

            case "refDocument":


                if (genericaSistemaBase.id > -100) {

                    console.log("refDocument, ");

                    const valRefDoc = genericaSistemaBase['uts'][`${"guid" + metadata.campo}`];

                    let sequenceTgContenedor = "";

                    if (genericaSistemaBase['uts'][`${selectedTipoGenerica.cgCampo}`] !== undefined) {
                        sequenceTgContenedor = genericaSistemaBase['uts'][`${selectedTipoGenerica.cgCampo}`] + "";
                    }
                    else {
                        let guid = window.crypto.randomUUID();
                        console.log(guid);

                        sequenceTgContenedor = guid;

                    }

                    //console.log("sequenceTgContenedor, ", selectedTipoGenerica, "genericaSistemaBase, ", genericaSistemaBase);
                    //if (genericaSistemaBase.id>0){
                    return (
                        <div className={"w-full lg:w-9 " + classNames({ 'fieldCustom p-invalid': !metadata.valido && metadata.ingresado })}>
                            <div>
                                {(valRefDoc !== null && valRefDoc !== undefined && valRefDoc !== "") ? (<Link target="_blank" icon="pi pi-download" rel="noopener noreferrer" href={"../file?guid=" + valRefDoc}>Adjunto</Link>) : <span>No hay archivos cargados</span>}
                            </div>

                            <Inplace closable ref={e => metadata.formRef = e} className="mt-3" style={{ width: '95%' }} >
                                <InplaceDisplay>
                                    Clic para Cargar
                                </InplaceDisplay>
                                <InplaceContent>

                                    <Document guidDocument={valRefDoc} tgRef={selectedTipoGenerica.tg} cgRef={sequenceTgContenedor} onDocumentChange={onDocumentChange} metadataRef={metadata} />

                                </InplaceContent>
                            </Inplace>
                        </div>

                    );

                }
                else { return (<span>Archivo no carga </span>) }

            case "captcha":
                return (
                    //<Captcha siteKey="6Le1RQEsAAAAAFHJRQA393Z4UoUzW31997qtvFuT" onResponse={(e) => { onInputChange({ "htmlValue": e.response.substring(0, 100), "origin": e }, metadata.campo, reFsGenericaSistemaBase) }} />

                    //<Captcha siteKey="6Le1RQEsAAAAAFHJRQA393Z4UoUzW31997qtvFuT" onResponse={(e) => { onInputChange({ "htmlValue": e.response.substring(0, 100), "origin": e }, metadata.campo, reFsGenericaSistemaBase) }} />
                    <ReCAPTCHA className={classNameInput} sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY} onChange={(value) => onInputChange({ "htmlValue": value.substring(0, 100), "origin": value }, metadata.campo, reFsGenericaSistemaBase)} // Save token to state
                    />

                );

            case "opt":
                return (

                    <>

                        <div className="flex flex-column align-items-center">
                            <p className="font-bold text-xl mb-2">Autentica con la clave de único uso (OPT)</p>
                            <p className="text-color-secondary block mb-5">Por favor ingresa el código enviado a tu correo o celular.</p>
                            <span>Si no lo ha recibido, por favor verifique en su celular o correo en los mensajes no deseados o bloqueados</span>
                            <div className={classNameInput}>
                                <InputOtp id={`inputOTP${metadata.tg}-${metadata.campo}`} value={val}
                                    onChange={(e) => onInputChange({ "htmlValue": e.value, "origin": e.value }, metadata.campo, reFsGenericaSistemaBase)}
                                    length={6} inputTemplate={customInput} style={{ gap: 0 }}

                                />
                            </div>
                            <div className="flex justify-content-between mt-5 align-self-stretch">
                                <Button label="Resend Code" link className="p-0"></Button>

                            </div>
                        </div>


                    </>


                );

            case "password":
                return (<Password id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                    value={val} ref={e => metadata.formRef = e} required
                    onChange={(e) => onInputChange(e, metadata.campo, reFsGenericaSistemaBase)}
                    className={classNameInput}
                    feedback={false} tabIndex={1} />);

            case "string": return (
                <InputText id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                    value={val} ref={e => metadata.formRef = e} required
                    onChange={(e) => onInputChange(e, metadata.campo, reFsGenericaSistemaBase)}
                    className={classNameInput}
                    minLength={metadata.valMin} maxLength={metadata.valMax}
                    keyfilter={getKeyfilterInputText(metadata.formatoDato)}
                />
            );


            default: return (<InputText id={`fieldEdit${metadata.tg}-${metadata.campo}`} aria-labelledby={`label${metadata.tg}-${metadata.campo}`}
                value={val} ref={e => metadata.formRef = e} required
                onChange={(e) => onInputChange(e, metadata.campo, reFsGenericaSistemaBase)}
                className={classNameInput}
                minLength={metadata.valMin} maxLength={metadata.valMax} />);

        }


    }

    const getKeyfilterInputText = (formatoDato) => {

        var res = "";
        switch (formatoDato) {
            case "NIT":
                res = "num";
                break;
            case "email":
                res = "email";
                break;
            default:
                res = "";
        }

        return res;

    }

    const showOverlayPanel = (e, _campo) => {
        let op = metadataGenericaSistemaForm.find(x => x.campo === _campo)
        op.formRef.toggle(e);
        //console.log(op.formRef);
        //op.formRef.visible=true;
    }

    const generarMensajeValidacionCampo = (metadata) => {

        let campo = metadata.campo;

        let val = genericaSistema['uts'][`${campo}`];

        let tieneMensajeError = submitting && metadata.tipoDato !== "boolean" && !val && metadata.mensajeError !== "";

        let textoError = tieneMensajeError ? "is required. " + metadata.mensajeError : "";

        //console.log("validaciones campos, ", val, tieneMensajeError, textoError, metadata);

        /*
        switch (metadata.tipoDato){
            case "boolean": return (<Checkbox id={`fieldEdit${metadata.tg+'-'+campo}`} checked={ val }  ref={e => metadataRef.columnRef = e} required onChange={(e) => onBooleanChange(e, campo)} className={classNames({ 'p-invalid': submitted && !genericaSistema.ctiTexto })}></Checkbox>); break;
            case "int": return ( <InputNumber id={`fieldEdit${metadata.tg+'-'+campo}`} value={ val } ref={e => metadataRef.columnRef = e} onValueChange={(e) => onInputNumberChange(e, campo)} />); break;
            case "double": return ( <InputNumber id={`fieldEdit${metadata.tg+'-'+campo}`} value={  val } ref={e => metadataRef.columnRef = e} onValueChange={(e) => onInputNumberChange(e, campo)}  mode="decimal" />); break;
            default: return (<InputText id={`fieldEdit${metadata.tg+'-'+campo}`} value={val } ref={e => metadataRef.columnRef = e} required  onChange={(e) => onInputChange(e, campo)} className={classNameInput} />); break;
        }
        */

        return (tieneMensajeError && <small className="p-invalid">{metadata.ctiTexto} {textoError}</small>);
    }

    const savegenericaSistema = async () => {

        setSubmitting(true);

        let dialog = genericaSistemaDialogRef.current;

        let validoGenerica = true;

        let newMetadataGenericaSistemaForm = [...metadataGenericaSistemaForm];

        let metadatasfiltered = [];

        if (genericaSistema.id <= 0) {
            metadatasfiltered = metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label"
                && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false
                && (x.esRequerido === true || x.requeridoParaNuevo === true))
        }
        else {
            metadatasfiltered = metadataGenericaSistemaForm.filter(x => x.tipoDato !== "label"
                && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false
                && (x.esRequerido === true || x.actualizableEnFormulario === true))

            //  incuir esto?       (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo))
        }

        /*
       newMetadataGenericaSistemaForm.filter(x => x.valido === false && x.tipoDato !== "label" && x.actualizableEnFormulario === true && x.esSoloLectura === false
           && !(x.tipoDato === "sequence" || (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo))))
           
           newMetadataGenericaSistemaForm.forEach(x => {
               validoGenerica = validoGenerica && x.valido;
               x.ingresado = true;
           });
           */


        let metadataFiltered = undefined;
        let metadata = undefined;
        let newMetada = undefined;
        let index = undefined;
        let comodin = "";

        for (let indexFiltered in metadatasfiltered) {

            metadataFiltered = metadatasfiltered[indexFiltered];
            index = newMetadataGenericaSistemaForm.findIndex(x => x.campo === metadataFiltered.campo);
            metadata = newMetadataGenericaSistemaForm[index];

            newMetada = generarValidadoresMetadata(metadata, undefined, true);
            newMetada.formRef = metadata.formRef;


            newMetadataGenericaSistemaForm[index] = newMetada;

            //newMetada.ingresado = true;

            if (newMetada.valido === false) {
                console.log("newMetada.valido", newMetada);
            }

            validoGenerica = validoGenerica && newMetada.valido;
            comodin = "";

        }

        setMetadataGenericaSistemaForm(newMetadataGenericaSistemaForm);

        console.log("newMetadataGenericaSistemaForm, ", metadatasfiltered.filter(x => x.valido === false));

        if (validoGenerica) {

            metadataGenericaSistemaForm.filter(x => x.esSoloLectura && x.valorDefecto !== null && x.valorDefecto !== "")
                .forEach(campoSoloLectura => {
                    let valDefault = undefined;

                    switch (campoSoloLectura.valorDefecto) {
                        case "__SYSTEM_NOW": valDefault = new Date(Date.now()); break;
                        case "__SYSTEM_ID_TERCERO_USER_NAME": valDefault = null; break;
                        case "__SYSTEM_UUID":
                            var uuid = window.crypto.randomUUID();
                            valDefault = uuid.toString(); break;
                        case "__UPDATE_SYSTEM_NOW": valDefault = new Date(Date.now()); break;
                        case "__UPDATE_SYSTEM_ID_TERCERO_USER_NAME": valDefault = null; break;
                    }

                    genericaSistema.uts[campoSoloLectura.campo] = valDefault;

                });

            console.log("savegenericaSistema, ", genericaSistema);

            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistema).then(response => {

                console.log("response, ", response);
                if (response.mensaje === "") {

                    let _genericaSistema = { ...genericaSistema };

                    let idOriginal = _genericaSistema.id;

                    if (genericaSistema.id > 0) {
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });
                    }
                    else {
                        _genericaSistema.id = response.id;
                        _genericaSistema.cti = response.cti;
                        _genericaSistema.uts[response.campoSequenceTg] = response.sequenceTg;
                        //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                        //_genericasSistema.unshift(_genericaSistema);
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });
                    }

                    if (requiereConfirmacionOPT) {
                        let newGenericaSistemaConfirmacionOpt =
                        {
                            id: response.id, idEmpresa: idEmpresa, tg:
                                selectedTipoGenericaConfirmacionOpt.tg, ctiTexto: "", uts: {}
                        };
                        setGenericaSistemaConfirmacionOpt(newGenericaSistemaConfirmacionOpt);
                        setEsperandoConfirmacionOPT(true);
                    }
                    else {
                        props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);
                    }

                    //setGenericasSistema(_genericasSistema);
                    //setGenericaSistemaDialog(false);
                    //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                }

                setSubmitting(false);

            });

        }
        else {
            setSubmitting(false);
            toast.current.show({ severity: 'error', summary: 'Error Message', detail: "Se encontraron errores en los datos" });
        }

    }

    const saveConfirmacionOPT = async () => {

        setSubmitting(true);

        let dialog = genericaSistemaDialogRef.current;

        let validoGenerica = true;

        let newMetadataGenericaSistemaConfirmacionOpt = [...metadataGenericaSistemaConfirmacionOpt];

        let metadatasfiltered = [];


        metadatasfiltered = metadataGenericaSistemaConfirmacionOpt.filter(x => x.tipoDato !== "label"
            && x.tipoDato !== "sequence" && x.esImprimible === true && x.esSoloLectura === false
            && (x.esRequerido === true || x.actualizableEnFormulario === true))

        //  incuir esto?       (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo))


        /*
       newMetadataGenericaSistemaForm.filter(x => x.valido === false && x.tipoDato !== "label" && x.actualizableEnFormulario === true && x.esSoloLectura === false
           && !(x.tipoDato === "sequence" || (selectedTipoGenerica.filtroUts && Object.keys(selectedTipoGenerica.filtroUts).includes(x.campo))))
           
           newMetadataGenericaSistemaForm.forEach(x => {
               validoGenerica = validoGenerica && x.valido;
               x.ingresado = true;
           });
           */


        let metadataFiltered = undefined;
        let metadata = undefined;
        let newMetada = undefined;
        let index = undefined;

        for (let indexFiltered in metadatasfiltered) {

            metadataFiltered = metadatasfiltered[indexFiltered];
            index = newMetadataGenericaSistemaConfirmacionOpt.findIndex(x => x.campo === metadataFiltered.campo);
            metadata = newMetadataGenericaSistemaConfirmacionOpt[index];

            newMetada = generarValidadoresMetadata(metadata, undefined, true, genericaSistemaConfirmacionOpt);
            newMetada.formRef = metadata.formRef;

            newMetadataGenericaSistemaConfirmacionOpt[index] = newMetada;

            //newMetada.ingresado = true;

            if (newMetada.valido === false) {
                console.log("newMetada.valido", newMetada);
            }

            validoGenerica = validoGenerica && newMetada.valido;

        }

        setMetadataGenericaSistemaConfirmacionOpt(newMetadataGenericaSistemaConfirmacionOpt);

        console.log("newMetadataGenericaSistemaForm, ", metadatasfiltered.filter(x => x.valido === false));

        if (validoGenerica) {

            metadataGenericaSistemaConfirmacionOpt.filter(x => x.esSoloLectura && x.valorDefecto !== null && x.valorDefecto !== "")
                .forEach(campoSoloLectura => {
                    let valDefault = undefined;

                    switch (campoSoloLectura.valorDefecto) {
                        case "__SYSTEM_NOW": valDefault = new Date(Date.now()); break;
                        case "__SYSTEM_ID_TERCERO_USER_NAME": valDefault = null; break;
                        case "__SYSTEM_UUID":
                            var uuid = window.crypto.randomUUID();
                            valDefault = uuid.toString(); break;
                        case "__UPDATE_SYSTEM_NOW": valDefault = new Date(Date.now()); break;
                        case "__UPDATE_SYSTEM_ID_TERCERO_USER_NAME": valDefault = null; break;
                    }

                    genericaSistemaConfirmacionOpt.uts[campoSoloLectura.campo] = valDefault;

                });

            if (genericaSistemaConfirmacionOpt.tg === "BAS_VSTA_TERCERO_INVITADO_INTENTO_AUTOREGISTRO_CONFIRMACION_OPT") {
                genericaSistemaConfirmacionOpt.uts["intentoAutoregistro"] = genericaSistema.uts["intentoAutoregistro"];
            }
            console.log("savegenericaSistema, ", genericaSistemaConfirmacionOpt);

            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistemaConfirmacionOpt).then(response => {

                console.log("response, ", response);
                if (response.mensaje === "") {

                    let _genericaSistema = { ...genericaSistemaConfirmacionOpt };

                    let idOriginal = _genericaSistema.id;

                    if (genericaSistema.id > 0) {
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });
                    }
                    else {
                        _genericaSistema.id = response.id;
                        _genericaSistema.cti = response.cti;
                        _genericaSistema.uts[response.campoSequenceTg] = response.sequenceTg;
                        //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                        //_genericasSistema.unshift(_genericaSistema);
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });
                    }

                    if (props.onSaveSuccessful) {
                        props.onSaveSuccessful(_genericaSistema, idOriginal, response.genericasSistemaAffected);
                    }

                    //setGenericasSistema(_genericasSistema);
                    //setGenericaSistemaDialog(false);
                    //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                }

                setSubmitting(false);

            });

        }
        else {
            setSubmitting(false);
            toast.current.show({ severity: 'error', summary: 'Error Message', detail: "Se encontraron errores en los datos" });
        }

    }

    const accept = () => {
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
        savegenericaSistema();
    };

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    };


    const genericaSistemaFooter = () => {
        if (utilizaDialog) {
            return (<>
                <ConfirmPopup target={refBtGuardarDialogFooter.current} acceptLabel='Sí' rejectLabel='No' visible={visibleConfirm} onHide={() => setVisibleConfirm(false)}
                    message="Está seguro que desea proceder?" icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />

                <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={props.onHideForm} disabled={submitting} />
                <Button label="Guardar" ref={refBtGuardarDialogFooter} icon="pi pi-check" className="p-button-text" onClick={() => selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_SEGUIMIENTO_CIERRE_CJ" ? setVisibleConfirm(true) : savegenericaSistema()} disabled={submitting} />
            </>);
        }
        else {
            return (<div className='col-12 mt-5'>
                <ConfirmPopup target={refBtGuardarDialogFooter.current} acceptLabel='Sí' rejectLabel='No' visible={visibleConfirm} onHide={() => setVisibleConfirm(false)}
                    message="Está seguro que desea proceder?" icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />

                <Button label="Guardar" ref={refBtGuardarDialogFooter} icon="pi pi-check" className="mt-4 bg-white text-green-600 surface-border" onClick={() => selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_SEGUIMIENTO_CIERRE_CJ" ? setVisibleConfirm(true) : savegenericaSistema()} disabled={submitting} />
            </div>);
        }
    }

    const confirmacionOPTFooter = () => {
        if (utilizaDialog) {
            return (<>
                <ConfirmPopup target={refBtGuardarDialogFooter.current} acceptLabel='Sí' rejectLabel='No' visible={visibleConfirm} onHide={() => setVisibleConfirm(false)}
                    message="Está seguro que desea proceder?" icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />

                <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={props.onHideForm} disabled={submitting} />
                <Button label="Guardar" ref={refBtGuardarDialogFooter} icon="pi pi-check" className="p-button-text" onClick={() => selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_SEGUIMIENTO_CIERRE_CJ" ? setVisibleConfirm(true) : saveConfirmacionOPT()} disabled={submitting} />
            </>);
        }
        else {
            return (<div className='col-12 mt-5'>
                <ConfirmPopup target={refBtGuardarDialogFooter.current} acceptLabel='Sí' rejectLabel='No' visible={visibleConfirm} onHide={() => setVisibleConfirm(false)}
                    message="Está seguro que desea proceder?" icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />

                <Button label="Guardar" ref={refBtGuardarDialogFooter} icon="pi pi-check" className="mt-4 bg-white text-green-600 surface-border" onClick={() => selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_SEGUIMIENTO_CIERRE_CJ" ? setVisibleConfirm(true) : saveConfirmacionOPT()} disabled={submitting} />
            </div>);
        }
    }

    const ctiTextoFiltroUtsBody = () => {

        if (selectedTipoGenerica.ctiTextoFiltroUts !== undefined && selectedTipoGenerica.ctiTextoFiltroUts !== "") {
            return (<p>{selectedTipoGenerica.ctiTextoFiltroUts}</p>);
        }
        else {
            return (<></>)
        }

    };
    const variablesExternasBody = () => {

        if (selectedTipoGenerica.variableRestriccionExterna !== undefined && selectedTipoGenerica.variableRestriccionExterna !== "" && !_.isEqual(selectedTipoGenerica.variableRestriccionExterna, {})) {
            return (<>
                <strong>Otras referencia</strong>
                {Object.keys(selectedTipoGenerica.variableRestriccionExterna).filter(x => x !== "" && x !== undefined).map(variableExterna => <p>{selectedTipoGenerica.variableRestriccionExterna[variableExterna].ctiTexto}</p>)}
            </>);
        }
        else {
            return (<></>)
        }

    };




    if (!cargado || !genericaSistemaDialog || etiquetasModulo.length === 0 || metadataGenericaSistemaForm === undefined || selectedTipoGenerica === undefined || selectedTipoGenerica.operaciones === undefined)
        return (<></>)
    else {
        let NoRequiereNiEsperaOPT = !(requiereConfirmacionOPT && esperandoConfirmacionOPT);

        if (NoRequiereNiEsperaOPT && utilizaDialog) {

            return (
                <div>
                    <Toast ref={toast} />
                    <Dialog id="dialogGenericaSistemaForm"
                        maximizable ref={genericaSistemaDialogRef} visible={genericaSistemaDialog}
                        style={{ width: '95%' }} header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + selectedTipoGenerica.ctiTexto}
                        modal className="p-fluid" footer={genericaSistemaFooter()} onHide={props.onHideForm}>

                        {ctiTextoFiltroUtsBody()}
                        {variablesExternasBody()}
                        <div className='grid'>
                            {generarCamposFormularioGenericaSistemaSeleccionada()}
                        </div>

                    </Dialog>
                </div>
            )
        }
        else if (NoRequiereNiEsperaOPT && !utilizaDialog) {

            return (
                <div className='grid'>
                    <Toast ref={toast} />

                    {ctiTextoFiltroUtsBody()}
                    {variablesExternasBody()}
                    <div className='grid'>
                        {generarCamposFormularioGenericaSistemaSeleccionada()}
                    </div>
                    {genericaSistemaFooter()}

                </div>
            )
        }
        //A continuación para la verificación del OPT del segundo paso.
        else if (!NoRequiereNiEsperaOPT && utilizaDialog) {

            return (
                <div>
                    <Toast ref={toast} />
                    <Dialog id="dialogGenericaSistemaForm"
                        maximizable ref={genericaSistemaDialogRef} visible={genericaSistemaDialog}
                        style={{ width: '95%' }} header={GetTextoEtiqueta("DIALOG_HEADER_TEXT") + " " + selectedTipoGenerica.ctiTexto}
                        modal className="p-fluid" footer={confirmacionOPTFooter} onHide={props.onHideForm}>

                        OPT


                    </Dialog>
                </div>
            )
        }
        else {

            return (
                <div className='grid'>
                    <Toast ref={toast} />

                    {generarCamposConfirmacionOPT()}

                    {confirmacionOPTFooter()}

                </div>
            )
        }
    }

});

export default Formulario;

